import { FC, ReactNode } from 'react';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

interface CustomModalProps {
    open: boolean;
    handleClose: () => void;
    title: ReactNode;
    subTitle?: string;
    children: ReactNode;
    actions?: ReactNode;
    isCentered?: boolean;
    isTableModal?: boolean;
}
const CustomModal: FC<CustomModalProps> = ({
    open,
    handleClose,
    title,
    subTitle,
    children,
    actions,
    isCentered = true,
    isTableModal,
}) => {
    return (
        // TO-DO: style modal to match designs
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            fullWidth={!isTableModal}
            maxWidth={!isTableModal && null}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isCentered ? 'center' : 'flex-start',
                    height: '100%',
                    paddingBottom: 0,
                }}
            >
                <DialogContentText sx={{ mb: 3 }}>{subTitle}</DialogContentText>
                {children}
            </DialogContent>
            <DialogActions sx={{ px: 3 }}>{actions}</DialogActions>
        </Dialog>
    );
};

export default CustomModal;
